import React from 'react';
import { IconProps } from './types';

const CrownFilled: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1.4166}
    height={size}
    viewBox="0 0 34 24"
  >
    <path
      d="M33.0754 6.89054C32.9642 6.83462 32.8383 6.8149 32.7153 6.83415C32.5923 6.8534 32.4784 6.91066 32.3896 6.99789L25.1856 14.0885L17.2243 0.271009C17.1661 0.187356 17.0885 0.119023 16.9981 0.0718338C16.9078 0.0246449 16.8074 0 16.7055 0C16.6035 0 16.5031 0.0246449 16.4128 0.0718338C16.3225 0.119023 16.2449 0.187356 16.1866 0.271009L8.2253 14.0885L1.02134 6.99789C0.932635 6.90778 0.817587 6.8482 0.692809 6.82775C0.568032 6.8073 0.439983 6.82704 0.327156 6.88412C0.214329 6.94119 0.122564 7.03265 0.0651131 7.14529C0.0076621 7.25793 -0.0125009 7.38591 0.00753589 7.51075L2.39295 23.4931C2.41452 23.6353 2.48675 23.7649 2.59634 23.858C2.70593 23.9512 2.84549 24.0016 2.98931 24H30.4216C30.5654 24.0016 30.705 23.9512 30.8146 23.858C30.9242 23.7649 30.9964 23.6353 31.018 23.4931L33.4034 7.51075C33.4213 7.38598 33.3992 7.25874 33.3403 7.14731C33.2813 7.03588 33.1886 6.94599 33.0754 6.89054Z"
      fill={color}
    />
  </svg>
);

export default CrownFilled;
